import React from 'react'
import { FormattedMessage } from 'react-intl'
import LazyImage from '../LazyImage/LazyImage'

const TC = {
  src: require('./logos/techcrunch.svg'),
  alt: 'TechCrunch',
}
const forbes = {
  src: require('./logos/forbes.svg'),
  alt: 'Forbes',
}
const wired = {
  src: require('./logos/wired.svg'),
  alt: 'Wired',
}
const cosmopolitan = {
  src: require('./logos/cosmopolitan.svg'),
  alt: 'Cosmopolitan',
}
const financialTimes = {
  src: require('./logos/financial-times.svg'),
  alt: 'Financial Times',
}

const logos = [TC, cosmopolitan, forbes, wired, financialTimes]

export default function AsSeenIn() {
  return (
    <section className="text-center">
      <h1 className="type-upper-fat mb-12 text-TypeSub md:mb-20 lg:mb-40">
        <FormattedMessage id="Press.asSeenIn" defaultMessage="As seen in" />
      </h1>
      <div className="flex flex-wrap justify-center lg:grid lg:grid-cols-5 lg:gap-6">
        {logos.map(({ src, alt }, i) => {
          return (
            <LazyImage
              width={300}
              height={60}
              className="my-12 w-1/2 md:my-16 lg:my-0 lg:w-auto"
              key={i}
              src={src}
              alt={alt}
            />
          )
        })}
      </div>
    </section>
  )
}
